import { graphql, useStaticQuery } from 'gatsby';
import { Box, Heading } from 'lucid-components-react';
import React from 'react';
import LazyLoad from 'react-lazyload';

import LucidContainer from 'components/lucid-container/lucid-container';
import { Drupal_ParagraphNineteenSocialProof } from 'generated/graphql';

interface Props {
  entity: Drupal_ParagraphNineteenSocialProof;
}

const NineteenSocialProof = ({ entity: { fieldHeader } }: Props) => {
  const {
    allNineteenSocialProofLogosJson: { edges }
  } = useStaticQuery(
    graphql`
      {
        allNineteenSocialProofLogosJson {
          edges {
            node {
              name
              logo
            }
          }
        }
      }
    `
  );

  return (
    <Box
      as="section"
      className="nineteen-social-proof"
      css={theme => ({ backgroundColor: theme.colors.indigo[90] })}
      py={6}
    >
      <LucidContainer>
        {fieldHeader && (
          <Heading as="h1" color="white" mb={8} variant="subheadS">
            {fieldHeader}
          </Heading>
        )}
        <Box
          css={{
            display: 'flex',
            listStyle: 'none',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            '&::after': {
              content: '""',
              flex: '0 1 48%'
            }
          }}
        >
          {edges.map(
            ({
              node: { name, logo }
            }: {
              node: { name: string; logo: string };
            }) => (
                /* eslint-disable-next-line react/jsx-indent */
                <Box
                  key={name}
                  css={theme => ({
                    backgroundColor: theme.colors.coolGrey[0],
                    borderRadius: theme.borderRadius,
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    padding: '1.25rem',
                    [`@media screen and (min-width: ${theme.breakpoints.tablet})`]: {
                      padding: `${theme.space[5]}px`
                    }
                  })}
                  flex={{
                    default: '0 1 45%',
                    mobile: '0 1 22%',
                    tablet: '0 1 18%'
                  }}
                  height={{ default: '75px', tablet: '112px' }}
                  mb={5}
                >
                  <LazyLoad offset={200}>
                    <img
                      alt={name}
                      css={{
                        display: 'inline-block',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        margin: 'auto'
                      }}
                      src={logo}
                    />
                  </LazyLoad>
                </Box>
              )
          )}
        </Box>
      </LucidContainer>
    </Box>
  );
};

export default NineteenSocialProof;

export const query = graphql`
  fragment nineteenSocialProof on Drupal_ParagraphNineteenSocialProof {
    fieldHeader
  }
`;
